import { useEffect, useState } from "react";
import getClassName from "../../utilities/getClassName";

const Switch = ({ disabled, classNames, value, callback, isOn = false, ariaLabel, controlled = false }) => {
    // State
    const [on, setOn] = useState(isOn);

    const checked = controlled ? isOn : on;

    // Toggle handler
    const toggleHandler = () => {
        value(!checked);
        if (!controlled) setOn(!checked);

        if (callback) {
            callback(!checked);
        }
    };

    let className = ["switch"];
    if (typeof classNames === "object") {
        className = className.concat(classNames);
    }
    if (checked) {
        className = className.concat(["switch--on"]);
    }

    useEffect(() => {
        setOn(isOn);
    }, [isOn]);

    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={ariaLabel}
            disabled={disabled}
            onClick={toggleHandler}
            className={getClassName(className)}
        >
            <span className="switch__knob" />
        </button>
    );
};

export default Switch;
